import { AxiosError } from "axios";

export class ForbiddenError extends Error {
  constructor(error: AxiosError) {
    super(error.message);
    this.message = 'error.forbidden';
    this.name = "ForbiddenError";
  }
}
